import { IHttpService } from "angular";
import { Observable, Subject, BehaviorSubject } from "rxjs";
import * as fileSaver from "file-saver";
import { ICapsuleFolder } from "../../typings/board/Models";
import { Constant } from "../common/utils/constants";

export const CAPSULE_SERVICE : string = "CapsuleService";
export interface IBlobResult {
    blob: Blob;
    error: string;
}

export class CapsuleService {

    public isDataAvailable: BehaviorSubject<boolean>;
    public isLockScreen: BehaviorSubject<boolean>;
    public isDownloadProgress: BehaviorSubject<boolean>;
    public existingCapsule : Subject<ICapsuleFolder>;
    public isShowHideGuide: BehaviorSubject<boolean>;
    public isShowHideModal: BehaviorSubject<boolean>;

    static $inject = ["$http", "$mdToast"];
    constructor(private $http: IHttpService, private $mdToast: ng.material.IToastService) {
        this.isDataAvailable = new BehaviorSubject(false);
        this.isLockScreen = new BehaviorSubject(true);
        this.isDownloadProgress = new BehaviorSubject(false);
        this.isShowHideGuide = new BehaviorSubject(false);
        this.isShowHideModal = new BehaviorSubject(false);
        this.existingCapsule = new Subject();
     }

     public showToast(message:string):void {
        this.$mdToast.show(this.$mdToast.simple().textContent(message).position("top right"));
    }

     public lookupCapsuleByPath(searchingPath: string, searchingPlace :ICapsuleFolder): ICapsuleFolder {
        if (searchingPath === searchingPlace.relativePath) {
            return searchingPlace;
        } else if (searchingPlace.subFolders) {
            var searchingElement : ICapsuleFolder = null;
            for(var i:number = 0; searchingElement == null && i < searchingPlace.subFolders.length; ++i) {
                searchingElement =  this.lookupCapsuleByPath(searchingPath, searchingPlace.subFolders[i]);
            }
            return searchingElement;
        } else {
            return null;
        }
    }

    public $initializeCapsule(): void {
        this.startingAsyncOperation();
        Observable.fromPromise(this.$http.get<ICapsuleFolder>("api/capsule/GetCapsuleFolders"))
        .map(response => {
            this.existingCapsule.next(response.data);
            this.isDataAvailable.next(true);
            this.isLockScreen.next(false);
        })
        .subscribe(succ => {
            this.stoppingAsyncOperation();
        },
        err => {
            this.stoppingAsyncOperation();
        });
    }
    public $getExistingCapsule(): Observable<ICapsuleFolder> {
        return this.existingCapsule.asObservable();
    }
    public $upload(capsuleFolder: ICapsuleFolder, file:File, override: Boolean): Observable<number> {
        this.startingAsyncOperation();
        return Observable.fromPromise(this.$http({
            method: "POST",
            url: "api/capsule/upload",
            headers: { "Content-Type": undefined },
            data: {capsuleFolder:capsuleFolder, file:file},
            transformRequest: function (data:any):FormData {
                var formData :FormData = new FormData();
                formData.append("path", data.capsuleFolder.relativePath);
                formData.append("file", file);
                formData.append("override", JSON.stringify(override));
                return formData;
            }
        })) .map(response => {
            this.$initializeCapsule();
            return response.status;
        });
    }

    public $move(sourceCapsule : ICapsuleFolder, destinationPath : string, override: Boolean): Observable<number> {
        this.startingAsyncOperation();
            return Observable.fromPromise(this.$http({
                method: "POST",
                url: "api/capsule/move",
                headers: { "Content-Type": undefined },
                data: {sourceCapsule: sourceCapsule, destinationPath: destinationPath, override: override},
                transformRequest: function (data:any):FormData {
                    var formData :FormData = new FormData();
                    formData.append("sourceCapsule", JSON.stringify(sourceCapsule));
                    formData.append("destinationPath", destinationPath);
                    formData.append("override", JSON.stringify(override));
                    return formData;
                }
            })).map(response => {
                this.$initializeCapsule();
                return response.status;
            });
        }


    public showHideGuide():void {
        this.isShowHideGuide.next(!this.isShowHideGuide.getValue());
        this.isLockScreen.next(this.isShowHideGuide.getValue());
    }
    public showHideModal():void {
        this.isShowHideModal.next(!this.isShowHideModal.getValue());
    }

    public $createFolder(destinationPath : string, folderName:string):Observable<number> {
        this.startingAsyncOperation();
        return Observable.fromPromise(this.$http({
            method: "POST",
            url: "api/capsule/createFolder",
            headers: { "Content-Type": undefined },
            data: {destinationPath:destinationPath, folderName:folderName},
            transformRequest: function (data:any):FormData {
                var formData :FormData = new FormData();
                formData.append("destinationPath", data.destinationPath);
                formData.append("folderName", data.folderName);
                return formData;
            },
        })).map(response => {
            this.$initializeCapsule();
            return response.status;
        });
    }

    public $duplicate(sourceCapsuleFolder : ICapsuleFolder, destinationPath : string, override: Boolean): Observable<number> {
        this.startingAsyncOperation();
        return Observable.fromPromise(this.$http({
            method: "POST",
            url: "api/capsule/duplicate",
            headers: { "Content-Type": undefined },
            data: {sourceCapsuleFolder: sourceCapsuleFolder, destinationPath: destinationPath, override: override},
            transformRequest: function (data:any):FormData {
                var formData :FormData = new FormData();
                formData.append("sourceCapsule", JSON.stringify(sourceCapsuleFolder));
                formData.append("destinationPath", destinationPath);
                formData.append("override", JSON.stringify(override));
                return formData;
            }
        })) .map(response => {
            this.$initializeCapsule();
            return response.status;
        });
    }
    public $rename(renamingFolder : ICapsuleFolder, newName: string): Observable<number> {
        this.startingAsyncOperation();
        return Observable.fromPromise(this.$http({
            method: "POST",
            data: { renamingFolder:renamingFolder, newName:newName },
            url: "api/capsule/rename",
            headers: { "Content-Type": undefined },
            transformRequest: function (data:any):FormData {
                var formData :FormData = new FormData();
                formData.append("renamingFolder", JSON.stringify(renamingFolder));
                formData.append("newName", newName);
                return formData;
            }
        })).map(response => {
            this.$initializeCapsule();
            return response.status;
        });
    }

    public $download(capsuleFolder : ICapsuleFolder, filename: string): void {
        this.isDownloadProgress.next(true);
        Observable.fromPromise(
            this.$http.post<any>("api/capsule/download", JSON.stringify(capsuleFolder),
            { responseType: "arraybuffer", cache: false }))
        .map(response => {
            var result: IBlobResult = { blob: null, error: "" };
            if (response.status === 200) {
            result.blob = new Blob([response.data], { type: "application/zip" });
            return result;
        }})
        .subscribe(res => {
            this.showToast(Constant.DOWNLOAD_COMPLETED);
            fileSaver.saveAs(res.blob, filename + Constant.ZIP_FORMAT);
            this.isDownloadProgress.next(false);
        },
    err =>  {
        this.showToast(Constant.DOWNLOAD_ABORTED);
        this.isDownloadProgress.next(false);
    });
}
    public $delete(deletionFolder : ICapsuleFolder): Observable<number> {
        this.startingAsyncOperation();
        return Observable.fromPromise(this.$http({
            method: "POST",
            data: JSON.stringify(deletionFolder),
            url: "api/capsule/delete",
        })).map(response => {
            this.$initializeCapsule();
            return response.status;
        });
    }

    private startingAsyncOperation(): void {
        this.isDataAvailable.next(false);
        this.isLockScreen.next(true);
    }

    public stoppingAsyncOperation(): void {
        this.isDataAvailable.next(true);
        this.isLockScreen.next(false);
    }


}


// WEBPACK FOOTER //
// ./app/capsule/capsule.service.ts